import { AboutCta } from '../sections/about/AboutCta';
import { AboutDecade } from '../sections/about/AboutDecade';
import { AboutFounders } from '../sections/about/AboutFounders';
import { AboutHero } from '../sections/about/AboutHero';
import { AboutOriginStory } from '../sections/about/AboutOriginStory';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './AboutPage.module.css';

export function AboutPage() {
  useDocumentTitle('About');

  return (
    <div className={styles.page}>
      <AboutHero />
      <AboutOriginStory />
      <AboutFounders />
      <AboutDecade />
      <AboutCta />
    </div>
  );
}
